import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createTranslator, useLanguage } from '../i18n/LanguageContext';
import { academyListTranslations } from '../i18n/translations';

const FUNCTIONS_BASE_URL = 'https://us-central1-mendyx-adafe.cloudfunctions.net';

const functionUrl = (name) => `${FUNCTIONS_BASE_URL}/${name}`;

const StageList = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = createTranslator(language, academyListTranslations);
  const [participantsCounts, setParticipantsCounts] = useState({});
  const [activeTab, setActiveTab] = useState('stages'); // 'stages' ou 'cours'
  const [filters, setFilters] = useState({
    location: null,
    type: null,
  });
  const [activeForm, setActiveForm] = useState(null); // Ajoute cette ligne

  const [adultFormData, setAdultFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    phone: '',
    niveau: 'P100 (Débutant)',
    nombrePersonnes: 1,
    typeCours: 'individuel',
    inscriptions: [],
    lieux: [] // Ajoutez cette ligne
  });
  
  const [childFormData, setChildFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    phone: '',
    nombrePersonnes: 1,
    typeCours: 'individuel',
    inscriptions: [],
    lieux: [] // Ajoutez cette ligne
  });
  

  const lieuxDisponibles = [
    { id: 'mettet', name: 'Padel Mettet' },
    { id: 'manage', name: 'Padel One Manage' },
  ];

  const [modalOpen, setModalOpen] = useState(false);
const [selectedImage, setSelectedImage] = useState('');

  const openModal = (imageSrc) => {
  setSelectedImage(imageSrc);
  setModalOpen(true);
};

const closeModal = () => {
  setModalOpen(false);
};

  // Données des stages
  const [stages, setStages] = useState([]);
  const [loadingStages, setLoadingStages] = useState(false);

  // Données des cours
  const courses = [
    // Cycles à Manage

    /*
    {
      id: 102,
      name: 'Cycle Intermédiaires Adultes - Manage',
      location: 'Padel One - Manage',
      type: 'cycle',
      startDate: '2025-09-21',
      endDate: '2025-12-21',
      time: 'Tous les dimanches 14h-15h30',
      players: 8,
      picture: 'padelone.jfif',
      price: 180,
      priceRange: '180€/mois',
      duration: '3 mois',
      ageGroup: 'Adultes',
    },
  
    // Cours à l'unité à Manage
    {
      id: 103,
      name: 'Cours Débutants à l\'unité - Manage',
      location: 'Padel One - Manage',
      type: 'unité',
      startDate: '2025-09-22',
      endDate: '2025-12-22',
      time: 'Tous les mercredis 18h-19h30',
      players: 6,
      picture: 'padelone.jfif',
      price: 30,
      priceRange: '30€/séance',
      ageGroup: 'Ados/Adultes',
    },
  
    // Cycles à Mettet
    {
      id: 104,
      name: 'Cycle Avancés Adultes - Mettet',
      location: 'Padel Mettet',
      type: 'cycle',
      startDate: '2025-09-23',
      endDate: '2025-12-23',
      time: 'Tous les jeudis 19h-20h30',
      players: 6,
      picture: 'padelmettet.jfif',
      price: 200,
      priceRange: '200€/mois',
      duration: '3 mois',
      ageGroup: 'Adultes',
    },
    {
      id: 105,
      name: 'Cycle Débutants Enfants (6-10 ans) - Mettet',
      location: 'Padel Mettet',
      type: 'cycle',
      startDate: '2025-09-24',
      endDate: '2025-12-24',
      time: 'Tous les vendredis 16h-17h30',
      players: 8,
      picture: 'padelmettet.jfif',
      price: 140,
      priceRange: '140€/mois',
      duration: '3 mois',
      ageGroup: '6-10 ans',
    },
  
    // Cours à l'unité à Mettet
    {
      id: 106,
      name: 'Cours Intermédiaires à l\'unité - Mettet',
      location: 'Padel Mettet',
      type: 'unité',
      startDate: '2025-09-25',
      endDate: '2025-12-25',
      time: 'Tous les vendredis 18h-19h30',
      players: 6,
      picture: 'padelmettet.jfif',
      price: 35,
      priceRange: '35€/séance',
      ageGroup: 'Ados/Adultes',
    },
  
    // Cycles à Namur
    {
      id: 107,
      name: 'Cycle Débutants Adultes - Namur',
      location: 'Padel Namur',
      type: 'cycle',
      startDate: '2025-09-26',
      endDate: '2025-12-26',
      time: 'Tous les samedis 11h-12h30',
      players: 8,
      picture: 'padelnamur.jfif',
      price: 160,
      priceRange: '160€/mois',
      duration: '3 mois',
      ageGroup: 'Adultes',
    },
  
    // Cours à l'unité à Namur
    {
      id: 108,
      name: 'Cours Débutants Enfants à l\'unité - Namur',
      location: 'Padel Namur',
      type: 'unité',
      startDate: '2025-09-27',
      endDate: '2025-12-27',
      time: 'Tous les samedis 14h-15h30',
      players: 6,
      picture: 'padelnamur.jfif',
      price: 25,
      priceRange: '25€/séance',
      ageGroup: '6-12 ans',
    },
    */
  ];

  const handleAdultLieuxChange = (lieuId) => {
    setAdultFormData(prev => {
      const newLieux = prev.lieux.includes(lieuId)
        ? prev.lieux.filter(l => l !== lieuId)
        : [...prev.lieux, lieuId];
      return { ...prev, lieux: newLieux };
    });
  };
  
  const handleChildLieuxChange = (lieuId) => {
    setChildFormData(prev => {
      const newLieux = prev.lieux.includes(lieuId)
        ? prev.lieux.filter(l => l !== lieuId)
        : [...prev.lieux, lieuId];
      return { ...prev, lieux: newLieux };
    });
  };
  
  
  const horairesParJour = {
    'Lundi': ['8h-12h (heures creuses)', '12h-17h (heures creuses)', '17h-21h', '21h-23h'],
    'Mardi': ['8h-12h (heures creuses)', '12h-17h (heures creuses)', '17h-21h', '21h-23h'],
    'Mercredi': ['8h-12h (heures creuses)', '12h-17h (heures creuses)', '17h-21h', '21h-23h'],
    'Jeudi': ['8h-12h (heures creuses)', '12h-17h (heures creuses)', '17h-21h', '21h-23h'],
    'Vendredi': ['8h-12h (heures creuses)', '12h-17h (heures creuses)', '17h-21h', '21h-23h'],
    'Samedi': ['8h-12h ', '12h-17h ', '17h-21h', '21h-23h'],
    'Dimanche': ['8h-12h ', '12h-17h ', '17h-21h', '21h-23h'],
  };
  const joursDisponibles = Object.keys(horairesParJour);

  const handleAdultTypeCoursChange = (e) => {
    setAdultFormData(prev => ({ ...prev, typeCours: e.target.value }));
  };
  
  const handleChildTypeCoursChange = (e) => {
    setChildFormData(prev => ({ ...prev, typeCours: e.target.value }));
  };
  
  
  const handleAdultInputChange = (e) => {
    const { name, value } = e.target;
    setAdultFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const handleChildInputChange = (e) => {
    const { name, value } = e.target;
    setChildFormData(prev => ({ ...prev, [name]: value }));
  };

  // Fonctions pour gérer le nombre de personnes
const handleAdultNombrePersonnesChange = (e) => {
  setAdultFormData(prev => ({ ...prev, nombrePersonnes: parseInt(e.target.value) }));
};

const handleChildNombrePersonnesChange = (e) => {
  setChildFormData(prev => ({ ...prev, nombrePersonnes: parseInt(e.target.value) }));
};

// Fonctions pour gérer les inscriptions (jours + horaires)
const toggleJourHoraireAdult = (jour, horaire) => {
  setAdultFormData(prev => {
    // Trouver l'index du jour dans les inscriptions
    const existingIndex = prev.inscriptions.findIndex(ins => ins.jour === jour);
    let newInscriptions = [...prev.inscriptions];

    if (existingIndex === -1) {
      // Si le jour n'existe pas, on l'ajoute avec l'horaire sélectionné
      newInscriptions.push({ jour, horaires: [horaire] });
    } else {
      // Si le jour existe, on gère les horaires
      const existingHoraires = [...newInscriptions[existingIndex].horaires];
      const horaireIndex = existingHoraires.indexOf(horaire);

      if (horaireIndex >= 0) {
        // Retirer l'horaire si déjà présent
        newInscriptions[existingIndex].horaires = existingHoraires.filter(h => h !== horaire);
      } else {
        // Ajouter l'horaire
        existingHoraires.push(horaire);
        newInscriptions[existingIndex].horaires = existingHoraires;
      }
    }

    return { ...prev, inscriptions: newInscriptions };
  });
};

const toggleJourHoraireChild = (jour, horaire) => {
  setChildFormData(prev => {
    const existingIndex = prev.inscriptions.findIndex(ins => ins.jour === jour);
    let newInscriptions = [...prev.inscriptions];

    if (existingIndex === -1) {
      newInscriptions.push({ jour, horaires: [horaire] });
    } else {
      const existingHoraires = [...newInscriptions[existingIndex].horaires];
      const horaireIndex = existingHoraires.indexOf(horaire);

      if (horaireIndex >= 0) {
        newInscriptions[existingIndex].horaires = existingHoraires.filter(h => h !== horaire);
      } else {
        existingHoraires.push(horaire);
        newInscriptions[existingIndex].horaires = existingHoraires;
      }
    }

    return { ...prev, inscriptions: newInscriptions };
  });
};

// Modifiez la partie des créneaux horaires dans le JSX pour qu'ils soient ouverts par défaut :
{joursDisponibles.map(jour => {
  const isJourSelected = adultFormData.inscriptions.some(ins => ins.jour === jour);
  const jourHoraires = isJourSelected ?
    adultFormData.inscriptions.find(ins => ins.jour === jour)?.horaires || [] :
    [];

  return (
    <div key={jour} className="border border-gray-200 rounded p-2 bg-gray-50">
      <div className="flex items-center mb-1">
        <input
          type="checkbox"
          id={`jour-adult-${jour}`}
          checked={isJourSelected}
          onChange={() => {
            if (isJourSelected) {
              setAdultFormData(prev => ({
                ...prev,
                inscriptions: prev.inscriptions.filter(ins => ins.jour !== jour)
              }));
            } else {
              setAdultFormData(prev => ({
                ...prev,
                inscriptions: [...prev.inscriptions, { jour, horaires: [] }]
              }));
            }
          }}
          className="h-3.5 w-3.5 text-[#6B46C1] rounded"
        />
        <label htmlFor={`jour-adult-${jour}`} className="ml-1.5 text-xs font-medium text-gray-700">
          {jour}
        </label>
      </div>
      {/* Toujours afficher les horaires */}
      <div className="grid grid-cols-1 gap-1 ml-4">
        {horairesParJour[jour].map(horaire => {
          const isHoraireSelected = jourHoraires.includes(horaire);

          return (
            <div key={horaire} className="flex items-center">
              <input
                type="checkbox"
                id={`horaire-adult-${jour}-${horaire}`}
                checked={isHoraireSelected}
                onChange={() => toggleJourHoraireAdult(jour, horaire)}
                className="h-3 w-3 text-[#6B46C1] rounded"
                disabled={!isJourSelected}
              />
              <label htmlFor={`horaire-adult-${jour}-${horaire}`} className="ml-1 text-xs text-gray-600">
                {horaire}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
})}

  
  const handleAdultLieuChange = (lieu) => {
    setAdultFormData(prev => {
      const newLieux = prev.lieux.includes(lieu)
        ? prev.lieux.filter(l => l !== lieu)
        : [...prev.lieux, lieu];
      return { ...prev, lieux: newLieux };
    });
  };
  
  const handleAdultHoraireChange = (horaire) => {
    setAdultFormData(prev => {
      const newHoraires = prev.horaires.includes(horaire)
        ? prev.horaires.filter(h => h !== horaire)
        : [...prev.horaires, horaire];
      return { ...prev, horaires: newHoraires };
    });
  };
  
  const handleChildLieuChange = (lieu) => {
    setChildFormData(prev => {
      const newLieux = prev.lieux.includes(lieu)
        ? prev.lieux.filter(l => l !== lieu)
        : [...prev.lieux, lieu];
      return { ...prev, lieux: newLieux };
    });
  };
  
  const handleChildHoraireChange = (horaire) => {
    setChildFormData(prev => {
      const newHoraires = prev.horaires.includes(horaire)
        ? prev.horaires.filter(h => h !== horaire)
        : [...prev.horaires, horaire];
      return { ...prev, horaires: newHoraires };
    });
  };
  
  useEffect(() => {
    const loadAcademyPublicData = async () => {
      try {
        setLoadingStages(true);

        const response = await fetch(functionUrl('protectedGetAcademyPublicData'));
        const academyData = await response.json();

        if (!response.ok) {
          throw new Error(academyData.error || 'Erreur serveur');
        }

        const publicStages = (academyData.stages || [])
          .map((stage) => ({
            ...stage,
            id: Number(stage.id ?? stage._docId),
          }))
          .filter((stage) => stage.archived !== true && stage.visible !== false)
          .sort((a, b) => {
            const dateA = a.startDate ? new Date(a.startDate).getTime() : 0;
            const dateB = b.startDate ? new Date(b.startDate).getTime() : 0;
  
            if (dateA !== dateB) return dateA - dateB;
  
            return Number(a.id || 0) - Number(b.id || 0);
          });
  
        const counts = {};
        publicStages.forEach((stage) => {
          counts[`stage_${stage.id}`] = Number(stage.participantsCount || 0);
        });
        (academyData.courses || []).forEach((course) => {
          const id = Number(course.id ?? course._docId);
          counts[`course_${id}`] = Number(course.participantsCount || 0);
        });

        setStages(publicStages);
        setParticipantsCounts(counts);
      } catch (error) {
        console.error('Erreur chargement des stages:', error);
      } finally {
        setLoadingStages(false);
      }
    };

    loadAcademyPublicData();
  }, []);

  const handleRegisterClick = (id, type) => {
    if (type === 'stage') {
      navigate(`/registerstage/${id}`);
    } else {
      navigate(`/registercourse/${id}`);
    }
  };

  const handleViewClick = (id, type) => {
    if (type === 'stage') {
      navigate(`/StageDetails`);
    } else {
      navigate(`/CourseDetails`);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  const renderCard = (item, type) => {
    const isFull = (participantsCounts[`${type}_${item.id}`] || 0) >= item.players;
    const countKey = `${type}_${item.id}`;

    const handleAdultInputChange = (e) => {
      const { name, value } = e.target;
      setAdultFormData(prev => ({ ...prev, [name]: value }));
    };
    
    const handleChildInputChange = (e) => {
      const { name, value } = e.target;
      setChildFormData(prev => ({ ...prev, [name]: value }));
    };
    
    const handleAdultLieuChange = (lieu) => {
      setAdultFormData(prev => {
        const newLieux = prev.lieux.includes(lieu)
          ? prev.lieux.filter(l => l !== lieu)
          : [...prev.lieux, lieu];
        return { ...prev, lieux: newLieux };
      });
    };
    
    const handleAdultHoraireChange = (horaire) => {
      setAdultFormData(prev => {
        const newHoraires = prev.horaires.includes(horaire)
          ? prev.horaires.filter(h => h !== horaire)
          : [...prev.horaires, horaire];
        return { ...prev, horaires: newHoraires };
      });
    };
    
    const handleChildLieuChange = (lieu) => {
      setChildFormData(prev => {
        const newLieux = prev.lieux.includes(lieu)
          ? prev.lieux.filter(l => l !== lieu)
          : [...prev.lieux, lieu];
        return { ...prev, lieux: newLieux };
      });
    };
    
    const handleChildHoraireChange = (horaire) => {
      setChildFormData(prev => {
        const newHoraires = prev.horaires.includes(horaire)
          ? prev.horaires.filter(h => h !== horaire)
          : [...prev.horaires, horaire];
        return { ...prev, horaires: newHoraires };
      });
    };
    
    

    return (


      
      <div key={item.id} className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 transition-all duration-300 hover:shadow-lg h-full flex flex-col">
        {/* Image */}
        <div className="h-48 w-full bg-gray-50 flex items-center justify-center overflow-hidden">
          <img
            src={item.picture}
            alt={item.name}
            className="w-full h-auto max-h-44 object-contain"
          />
        </div>

        {/* Contenu */}
        <div className="p-6 flex-grow">
          <h3 className="text-xl font-bold text-[#6B46C1] mb-4">{item.name}</h3>

          <div className="space-y-3 mb-6 flex-grow">
            <div className="flex items-center text-gray-600">
         
            </div>
            {type === 'stage' ? (
  <>
    {/* Affichage pour les stages */}
    <div className="flex items-center text-gray-600">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-[#6B46C1]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
      <span>{item.location}</span>
    </div>
    <div className="flex items-center text-gray-600">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-[#6B46C1]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
      <span>{formatDate(item.startDate)}</span>
    </div>
    <div className="flex items-center text-gray-600">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-[#6B46C1]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>{item.time}</span>
    </div>
  </>
) : (
  <>
    {/* Affichage pour les cours */}
    <div className="space-y-2">
      {/* Location */}
      <div className="flex items-center text-gray-600">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-[#6B46C1]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        </svg>
        <span>{item.location}</span>
      </div>

      {/* Type et Âge */}
      <div className="flex gap-4">
        <div className="flex items-center text-gray-600">
          <span className="mr-1" style={{ color: '#9B59B6' }}>📅</span>
          <span>{item.type === 'cycle' ? 'Cycle' : 'À l\'unité'}</span>
        </div>
        {item.ageGroup && (
          <div className="flex items-center text-gray-600">
            <span className="mr-1" style={{ color: '#9B59B6' }}>👶</span>
            <span>{item.ageGroup}</span>
          </div>
        )}
      </div>

      {/* Dates */}
      <div className="flex items-center text-gray-600">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-[#6B46C1]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <span>Du {formatDate(item.startDate)} au {formatDate(item.endDate)}</span>
      </div>

      {/* Horaire */}
      <div className="flex items-center text-gray-600">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-[#6B46C1]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>{item.time}</span>
      </div>

      {/* Durée (si cycle) */}
      {item.type === 'cycle' && (
        <div className="flex items-center text-gray-600">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-[#6B46C1]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>Durée: {item.duration}</span>
        </div>
      )}
    </div>
  </>
)}


            <div className="flex items-center text-gray-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-[#6B46C1]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zm-14 0a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <span>{participantsCounts[countKey] || 0} / {item.players} inscrits</span>
            </div>

            <div className="flex items-center text-gray-600">
              <span className="mr-2" style={{ color: '#9B59B6' }}>🟣</span>
              <span>{item.priceRange}</span>
            </div>

            <div className="flex items-center text-gray-800 font-semibold">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-[#6B46C1]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>{item.price}€</span>
            </div>
          </div>


          {item.infoPrice && (
  <div className="mt-3 p-3 bg-purple-50 border border-purple-200 rounded-lg">
    <p className="text-sm font-semibold text-[#6B46C1] mb-1">
      ⚠️ Informations paiement
    </p>

    <p className="text-sm text-gray-700 leading-relaxed">
      {item.infoPrice}
    </p>
  </div>
)}

          {/* Boutons */}
          <div className="flex gap-4 mt-auto">
            <button
              onClick={() => handleRegisterClick(item.id, type)}
              disabled={isFull}
              className={`flex-1 py-2 px-4 rounded-lg font-medium transition-colors duration-200 ${
                isFull
                  ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                  : 'bg-[#6B46C1] text-white hover:bg-[#553C9A]'
              }`}
            >
              {isFull ? t('full') : t('register')}
            </button>
            <button
              onClick={() => handleViewClick(item.id, type)}
              className="flex-1 py-2 px-4 rounded-lg font-medium border border-[#6B46C1] text-[#6B46C1] hover:bg-[#6B46C1] hover:text-white transition-colors duration-200"
            >
              {t('details')}
            </button>
          </div>
        </div>
      </div>
    );
  };
  const filteredCourses = courses.filter(course => {
    const locationMatch = filters.location ? course.location.includes(filters.location) : true;
    const typeMatch = filters.type ? course.type === filters.type : true;
    return locationMatch && typeMatch;
  });
  return (
<section className="container mx-auto px-4 py-12 mt-8">
      <h2 className="text-3xl font-bold text-center text-[#6B46C1] mb-8">{t('brandAcademy')}</h2>

      {/* Onglets */}
      <div className="flex justify-center gap-4 mb-12">
        <button
          onClick={() => setActiveTab('stages')}
          className={`px-6 py-2 rounded-full text-sm font-semibold border transition ${
            activeTab === 'stages'
              ? 'bg-[#4c2f8e] text-white border-[#4c2f8e]'
              : 'bg-white text-[#4c2f8e] border-[#4c2f8e] hover:bg-[#4c2f8e] hover:text-white'
          }`}
        >
          {t('stages')}
        </button>

      </div>
     

      {activeTab === 'cours' && (
  <>
    <div className="flex justify-center mb-6">
      <button
        onClick={() => setActiveForm('adult')}
        className="px-6 py-2 bg-[#6B46C1] text-white rounded-lg font-medium hover:bg-[#553C9A] transition-colors"
      >
        {t('registerCourse')}
      </button>
    </div>
    {activeForm && (
      <div className="flex justify-center gap-4 mb-6">
        <button
          onClick={() => setActiveForm('adult')}
          className={`px-4 py-2 rounded-lg text-sm font-medium border-2 transition ${
            activeForm === 'adult' ? 'bg-[#6B46C1] text-white border-[#6B46C1]' : 'bg-white text-[#6B46C1] border-[#6B46C1] hover:bg-[#f3f0ff]'
          }`}
        >
          {t('adultCourse')}
        </button>
        <button
          onClick={() => setActiveForm('child')}
          className={`px-4 py-2 rounded-lg text-sm font-medium border-2 transition ${
            activeForm === 'child' ? 'bg-[#6B46C1] text-white border-[#6B46C1]' : 'bg-white text-[#6B46C1] border-[#6B46C1] hover:bg-[#f3f0ff]'
          }`}
        >
          {t('childCourse')}
        </button>
      </div>
    )}
    {activeForm && (
      <div className="flex flex-col lg:flex-row gap-6 items-start mb-6 max-w-6xl mx-auto">
{/* Image gauche */}
<div className="w-full lg:w-1/4 bg-white rounded-lg shadow-lg border border-gray-200 p-4 flex-shrink-0 h-[400px]">
  <img
    src="/tarif-adulte.jpg"
    alt="Tarifs cours adultes"
    className="w-full h-full object-contain rounded-lg"
    onClick={() => openModal('/tarif-adulte.jpg')}
  />
</div>
        {/* Formulaires */}
        <div className="w-full lg:w-2/4">
          {activeForm === 'adult' && (
            <div className="bg-white rounded-lg shadow-md border border-gray-200 p-4">
              <h3 className="text-lg font-semibold text-[#6B46C1] mb-3">{t('adultTitle')}</h3>
              <form
                className="space-y-3"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const formatInscriptions = (inscriptions, lieux) => {
                    if (!inscriptions || inscriptions.length === 0) return [];
                    return {
                      inscriptions: inscriptions.map(ins => ({
                        jour: ins.jour,
                        horaires: ins.horaires
                      })),
                      lieux: lieuxDisponibles.filter(lieu => lieux.includes(lieu.id)).map(lieu => lieu.name)
                    };
                  };
                  try {
                    const response = await fetch(
                      'https://us-central1-mendyx-adafe.cloudfunctions.net/sendCourseEmail',
                      {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                          ...adultFormData,
                          type: 'adulte',
                          language,
                          ...formatInscriptions(adultFormData.inscriptions, adultFormData.lieux)
                        }),
                      }
                    );
                    if (response.ok) {
                      alert(t('sent'));
                      setAdultFormData({
                        nom: '',
                        prenom: '',
                        email: '',
                        phone: '',
                        niveau: 'P100 (Débutant)',
                        typeCours: 'individuel',
                        nombrePersonnes: 1,
                        inscriptions: [],
                        lieux: []
                      });
                    } else {
                      alert(t('error'));
                    }
                  } catch (error) {
                    console.error('Erreur:', error);
                    alert(t('error'));
                  }
                }}
              >
                <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                  <div>
                    <input
                      type="text"
                      name="nom"
                      value={adultFormData.nom}
                      onChange={handleAdultInputChange}
                      placeholder={t('lastName')}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="prenom"
                      value={adultFormData.prenom}
                      onChange={handleAdultInputChange}
                      placeholder={t('firstName')}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      name="email"
                      value={adultFormData.email}
                      onChange={handleAdultInputChange}
                      placeholder={t('email')}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="tel"
                      name="phone"
                      value={adultFormData.phone}
                      onChange={handleAdultInputChange}
                      placeholder={t('phone')}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm"
                      required
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                  <div>
                    <select
                      name="niveau"
                      value={adultFormData.niveau}
                      onChange={handleAdultInputChange}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm"
                    >
                      {['P100 (Débutant)', 'P150', 'P200', 'P300', 'P400','P500'].map(level => (
                        <option key={level} value={level}>{level}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <select
                      value={adultFormData.typeCours}
                      onChange={handleAdultTypeCoursChange}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm"
                    >
                      <option value="individuel">{t('individual')}</option>
                      <option value="collectif">{t('group')}</option>
                    </select>
                  </div>
                  <div>
                    <select
                      value={adultFormData.nombrePersonnes}
                      onChange={handleAdultNombrePersonnesChange}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm"
                      disabled={adultFormData.typeCours === 'individuel'}
                    >
                      {[1, 2, 3, 4].map(num => (
                        <option key={num} value={num}>{t('people', { count: num })}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="mt-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">{t('locations')}</label>
                  <p className="text-xs text-gray-500 mb-2">{t('selectLocations')}</p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
                    {lieuxDisponibles.map(lieu => (
                      <div key={lieu.id} className="flex items-center">
                        <input
                          type="checkbox"
                          id={`lieu-adult-${lieu.id}`}
                          checked={adultFormData.lieux.includes(lieu.id)}
                          onChange={() => handleAdultLieuxChange(lieu.id)}
                          className="h-4 w-4 text-[#6B46C1] rounded"
                        />
                        <label htmlFor={`lieu-adult-${lieu.id}`} className="ml-2 text-sm text-gray-700">
                          {lieu.name}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">{t('timeSlots')}</label>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 max-h-64 overflow-y-auto">
                    {joursDisponibles.map(jour => {
                      const isJourSelected = adultFormData.inscriptions.some(ins => ins.jour === jour);
                      const jourHoraires = isJourSelected ?
                        adultFormData.inscriptions.find(ins => ins.jour === jour)?.horaires || [] :
                        [];
                      return (
                        <div key={jour} className="border border-gray-200 rounded p-2 bg-gray-50">
                          <div className="flex items-center mb-1">
                            <input
                              type="checkbox"
                              id={`jour-adult-${jour}`}
                              checked={isJourSelected}
                              onChange={() => {
                                if (isJourSelected) {
                                  setAdultFormData(prev => ({
                                    ...prev,
                                    inscriptions: prev.inscriptions.filter(ins => ins.jour !== jour)
                                  }));
                                } else {
                                  setAdultFormData(prev => ({
                                    ...prev,
                                    inscriptions: [...prev.inscriptions, { jour, horaires: [] }]
                                  }));
                                }
                              }}
                              className="h-3.5 w-3.5 text-[#6B46C1] rounded"
                            />
                            <label htmlFor={`jour-adult-${jour}`} className="ml-1.5 text-xs font-medium text-gray-700">
                              {jour}
                            </label>
                          </div>
                          <div className="grid grid-cols-1 gap-1 ml-4">
                            {horairesParJour[jour].map(horaire => {
                              const isHoraireSelected = jourHoraires.includes(horaire);
                              return (
                                <div key={horaire} className="flex items-center">
                                  <input
                                    type="checkbox"
                                    id={`horaire-adult-${jour}-${horaire}`}
                                    checked={isHoraireSelected}
                                    onChange={() => toggleJourHoraireAdult(jour, horaire)}
                                    className="h-3 w-3 text-[#6B46C1] rounded"
                                    disabled={!isJourSelected}
                                  />
                                  <label htmlFor={`horaire-adult-${jour}-${horaire}`} className="ml-1 text-xs text-gray-600">
                                    {horaire}
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="flex justify-end mt-3">
                  <button
                    type="submit"
                    className="px-4 py-1.5 bg-[#6B46C1] text-white rounded-md text-sm font-medium hover:bg-[#553C9A] transition-colors"
                  >
                    {t('register')}
                  </button>
                </div>
              </form>
            </div>
          )}
          {activeForm === 'child' && (
            <div className="bg-white rounded-lg shadow-md border border-gray-200 p-4">
              <h3 className="text-lg font-semibold text-[#6B46C1] mb-3">{t('childTitle')}</h3>
              <form
                className="space-y-3"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const formatInscriptions = (inscriptions) => {
                    if (!inscriptions || inscriptions.length === 0) return [];
                    return inscriptions.map(ins => ({
                      jour: ins.jour,
                      horaires: ins.horaires
                    }));
                  };
                  try {
                    const response = await fetch(
                      'https://us-central1-mendyx-adafe.cloudfunctions.net/sendCourseEmail',
                      {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                          ...childFormData,
                          type: 'enfant',
                          language,
                          ...formatInscriptions(childFormData.inscriptions, childFormData.lieux)
                        }),
                      }
                    );
                    if (response.ok) {
                      alert(t('sent'));
                      setChildFormData({
                        nom: '',
                        prenom: '',
                        email: '',
                        phone: '',
                        typeCours: 'individuel',
                        nombrePersonnes: 1,
                        inscriptions: [],
                        lieux: []
                      });
                    } else {
                      alert(t('error'));
                    }
                  } catch (error) {
                    console.error('Erreur:', error);
                    alert(t('error'));
                  }
                }}
              >
                <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                  <div>
                    <input
                      type="text"
                      name="nom"
                      value={childFormData.nom}
                      onChange={handleChildInputChange}
                      placeholder={t('childLastName')}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      name="prenom"
                      value={childFormData.prenom}
                      onChange={handleChildInputChange}
                      placeholder={t('childFirstName')}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="email"
                      name="email"
                      value={childFormData.email}
                      onChange={handleChildInputChange}
                      placeholder={t('parentEmail')}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="tel"
                      name="phone"
                      value={childFormData.phone}
                      onChange={handleChildInputChange}
                      placeholder={t('parentPhone')}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm"
                      required
                    />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                  <div>
                    <select
                      value={childFormData.typeCours}
                      onChange={handleChildTypeCoursChange}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm"
                    >
                      <option value="individuel">{t('individual')}</option>
                      <option value="collectif">{t('group')}</option>
                    </select>
                  </div>
                  <div>
                    <select
                      value={childFormData.nombrePersonnes}
                      onChange={handleChildNombrePersonnesChange}
                      className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm"
                      disabled={childFormData.typeCours === 'individuel'}
                    >
                      {[1, 2, 3].map(num => (
                        <option key={num} value={num}>{t('children', { count: num })}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="mt-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">{t('locations')}</label>
                  <p className="text-xs text-gray-500 mb-2">{t('selectLocations')}</p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2">
                    {lieuxDisponibles.map(lieu => (
                      <div key={lieu.id} className="flex items-center">
                        <input
                          type="checkbox"
                          id={`lieu-child-${lieu.id}`}
                          checked={childFormData.lieux.includes(lieu.id)}
                          onChange={() => handleChildLieuxChange(lieu.id)}
                          className="h-4 w-4 text-[#6B46C1] rounded"
                        />
                        <label htmlFor={`lieu-child-${lieu.id}`} className="ml-2 text-sm text-gray-700">
                          {lieu.name}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">{t('timeSlots')}</label>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 max-h-64 overflow-y-auto">
                    {joursDisponibles.map(jour => {
                      const isJourSelected = childFormData.inscriptions.some(ins => ins.jour === jour);
                      const jourHoraires = isJourSelected ?
                        childFormData.inscriptions.find(ins => ins.jour === jour)?.horaires || [] :
                        [];
                      return (
                        <div key={jour} className="border border-gray-200 rounded p-2 bg-gray-50">
                          <div className="flex items-center mb-1">
                            <input
                              type="checkbox"
                              id={`jour-child-${jour}`}
                              checked={isJourSelected}
                              onChange={() => {
                                if (isJourSelected) {
                                  setChildFormData(prev => ({
                                    ...prev,
                                    inscriptions: prev.inscriptions.filter(ins => ins.jour !== jour)
                                  }));
                                } else {
                                  setChildFormData(prev => ({
                                    ...prev,
                                    inscriptions: [...prev.inscriptions, { jour, horaires: [] }]
                                  }));
                                }
                              }}
                              className="h-3.5 w-3.5 text-[#6B46C1] rounded"
                            />
                            <label htmlFor={`jour-child-${jour}`} className="ml-1.5 text-xs font-medium text-gray-700">
                              {jour}
                            </label>
                          </div>
                          <div className="grid grid-cols-1 gap-1 ml-4">
                            {horairesParJour[jour].map(horaire => {
                              const isHoraireSelected = jourHoraires.includes(horaire);
                              return (
                                <div key={horaire} className="flex items-center">
                                  <input
                                    type="checkbox"
                                    id={`horaire-child-${jour}-${horaire}`}
                                    checked={isHoraireSelected}
                                    onChange={() => toggleJourHoraireChild(jour, horaire)}
                                    className="h-3 w-3 text-[#6B46C1] rounded"
                                    disabled={!isJourSelected}
                                  />
                                  <label htmlFor={`horaire-child-${jour}-${horaire}`} className="ml-1 text-xs text-gray-600">
                                    {horaire}
                                  </label>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="flex justify-end mt-3">
                  <button
                    type="submit"
                    className="px-4 py-1.5 bg-[#6B46C1] text-white rounded-md text-sm font-medium hover:bg-[#553C9A] transition-colors"
                  >
                    {t('register')}
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>

        {/* Image droite */}
{/* Image droite */}
<div className="w-full lg:w-1/4 bg-white rounded-lg shadow-lg border border-gray-200 p-4 flex-shrink-0 h-[400px]">
  <img
    src="/tarif-enfant.jpg"
    alt="Tarifs cours enfants"
    className="w-full h-full object-contain rounded-lg"
    onClick={() => openModal('/tarif-enfant.jpg')}
  />
</div>
      </div>
    )}

{modalOpen && (
  <div
    className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
    onClick={closeModal}
  >
    <div
      className="relative max-w-4xl max-h-[90vh] bg-white rounded-lg overflow-hidden shadow-2xl"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={closeModal}
        className="absolute top-2 right-2 text-white bg-black bg-opacity-50 rounded-full w-8 h-8 flex items-center justify-center z-10"
      >
        ✕
      </button>
      <img
        src={selectedImage}
        alt="Tarifs agrandis"
        className="w-full h-full object-contain max-h-[80vh]"
      />
    </div>
  </div>
)}

  </>
)}




      {/* Contenu selon l'onglet actif */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
      {activeTab === 'stages'
  ? (
      loadingStages ? (
        <div className="col-span-full text-center text-gray-500">
          Chargement des stages...
        </div>
      ) : stages.length === 0 ? (
        <div className="col-span-full text-center text-gray-500">
          Aucun stage disponible pour le moment.
        </div>
      ) : (
        stages.map(stage => renderCard(stage, 'stage'))
      )
    )
  : courses.filter(course => {
      const locationMatch = filters.location ? course.location.includes(filters.location) : true;
      const typeMatch = filters.type ? course.type === filters.type : true;
      return locationMatch && typeMatch;
    }).map(course => renderCard(course, 'course'))}
</div>


    </section>

    
  );
};

export default StageList;
